<template>
  <div class="w-full">
    <t-form
      ref="form"
      class="postal-form-step"
      @submit="onSubmit"
      @submit.prevent
    >
      <h6 class="input-header">Vul hier jouw postcode in</h6>

      <div class="postal-form-step__form">
        <PostalSeparateInputs
          class="postal-form-step__separate-inputs"
          :error-messages="errorMessages"
          @result="onResult"
          @change="onChange"
        />

        <FormStepSubmitButton
          id="submitPostal"
          class="postal-form-step__btn"
          text="Ga verder"
        />
      </div>

      <ServiceField
        ref="service"
        hidden
        :init-with-value="serviceId"
        @result="onResult"
        @change="onChange"
      />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import ServiceField from 'chimera/all/components/form/fields/service/ServiceField'
import PostalSeparateInputs from 'chimera/all/components/form/fields/postal/PostalSeparateInputs.nl'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { PD_10103_REMOVE_DORMER_QUESTIONS } from 'chimera/all/constants/experiments'
import { dormerDefaultNL } from 'chimera/dormer/service'
import DefaultNextStep from '~/pages/offertes-aanvragen/type-dakkapel'
import VariantNextStep from '~/pages/offertes-aanvragen/wanneer-dakkapel-plaatsen'

export default {
  name: 'PostalFormStep',

  components: {
    PostalSeparateInputs,
    FormErrorMessages,
    ServiceField,
  },

  extends: AbstractFormStep,

  /**
   * @returns {object}
   */
  data() {
    return {
      serviceId: dormerDefaultNL.id,
    }
  },

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Expose experiment and transition to next step.
     * Exposure happens here (not on mount) so only users who
     * complete the postal step become experiment participants.
     */
    async transition() {
      const { getExperiment, isVariant } = useExperiments(this.$store)
      const experiment = await getExperiment(PD_10103_REMOVE_DORMER_QUESTIONS)
      this.routeTo(isVariant(experiment, 1) ? VariantNextStep : DefaultNextStep)
    },
  },
}
</script>
